import {
    StartProcess,
    Task,
    CompleteTask,
    HistoricProcessAndTaskInstances,
    QueueResponse
} from "@/api/CamundaController";
import { history } from "@/core/helpers/history";
import {
    startLoading,
    stopLoading,
    updateTaskModel,
    updateTaskButton,
    openSnackBar,
    closeSnackBar,
    updateSubProcessDefinitionKey,
    updateTaskVariables,
    openBackDrop,
    closeBackDrop,
    openConfirm,
    closeConfirm,
    updateFlowButton
} from "@/redux/modules/Process";
import { actions as headerActions } from "@/redux/modules/Header";
import { actions as cacheActions } from "@/redux/modules/Cache";
import { store } from "@/core/helpers/store";
import { api } from "@/api/Api";
import { PopupSnackBarProps } from "@/components/PopupSnackBar";
import { QueueEnum } from '@/constatns';
import { ReactNode } from 'react';

const basePath = process.env.PUBLIC_URL;

class ProcessManger {
    public async start(request: StartProcess, redirect = true) {
        this.startLoading();

        let check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor);

        if (check) {
            var userDevice = "MOBILE";
        } else {
            var userDevice = "DESKTOP";
        }
        await api.camunda
            .start({
                processDefinitionKey: request.processDefinitionKey,
                variables: { ...request.variables, userAgent: userDevice },
            })
            .then((process) => {
                // Без перехода остаёмся на текущей странице, и её задачу в сторе трогать
                // нельзя: иначе, например, после перемещения между кассами taskModel
                // становится задачей перемещения (или null), и закрытие кассы падает.
                if (redirect) {
                    this.updateTaskModelWithHistory(process.task);
                    this.redirectTo((process || {}).task);
                }
                this.stopLoading();
            });
    }


    public async startPublic(request: StartProcess) {
        this.startLoading();

        let check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor);

        if (check) {
            var userDevice = "MOBILE";
        } else {
            var userDevice = "DESKTOP";
        }
        api.camunda
            .startPublic({
                processDefinitionKey: request.processDefinitionKey,
                variables: { ...request.variables, userAgent: userDevice },
            })
            .then((process) => {
                this.stopLoading();
                this.updateTaskModelWithHistory(process.task);
                // if (request.processDefinitionKey != "referral-requests") {
                //   this.redirectTo((process || {}).task);
                // }
            });
    }

    public startSubProcess(processDefinitionKey: string, blockUI?: boolean) {
        store.dispatch(updateSubProcessDefinitionKey(processDefinitionKey));
        this.completeTask(blockUI);
    }

    public startSubProcessMsg(
        processDefinitionKey: string,
        msg?: string,
        blockUI?: boolean
    ) {
        store.dispatch(updateSubProcessDefinitionKey(processDefinitionKey));
        this.completeTaskMsg(blockUI, msg);
    }

    private getCompleteTask(variables?: any): CompleteTask {
        return {
            taskId: store.getState().process.taskModel.id,
            processInstanceId: store.getState().process.taskModel.processInstanceId,
            variables: {
                ...(variables ?? store.getState().process.taskModel.variables),
            },
        };
    }

    private completingTaskIds = new Set<string>();

    private beginCompleting(taskId?: string): boolean {
        if (!taskId) return true;
        if (this.completingTaskIds.has(taskId)) return false;

        this.completingTaskIds.add(taskId);
        return true;
    }

    private endCompleting(taskId?: string) {
        if (!!taskId) this.completingTaskIds.delete(taskId);
    }

    private isTaskGoneError(error: any): boolean {
        if (error?.response?.status === 404) return true;

        const message = error?.response?.data?.message || error?.response?.data?.Message || "";
        return /cannot be found|does not exist|not found|не найден/i.test(String(message));
    }

    private async findCurrentProcessTaskId(task: Task): Promise<string | undefined> {
        const processKey = task?.processDefinitionKey || (task?.processDefinitionId || "").split(":")[0];
        if (!processKey || (!task?.processInstanceId && !task?.businessKey)) return undefined;

        const queues = await api.camunda.getUserQueues();
        const queue = queues?.find((item) => item?.process === processKey);
        if (!queue?.id) return undefined;

        const res: QueueResponse = await api.camunda.getQueueList(queue.id, 1, 100);

        return res?.queue?.find((row: any) => {
            if (!row?.taskId) return false;

            if (!!row.processInstanceId && !!task.processInstanceId) {
                return row.processInstanceId === task.processInstanceId;
            }

            const rowBusinessKey = row["task.businessKey"] ?? row.taskBusinessKey ?? row.businessKey;
            return !!rowBusinessKey && !!task.businessKey && String(rowBusinessKey) === String(task.businessKey);
        })?.taskId;
    }

    public async resumeCurrentTask(): Promise<boolean> {
        const task = store.getState().process.taskModel;
        const nextTaskId = await this.findCurrentProcessTaskId(task);

        if (!nextTaskId || nextTaskId === task?.id) return false;

        await this.claimTask(nextTaskId);
        return true;
    }

    private async resumeMovedProcess(completedTaskId?: string): Promise<boolean> {
        try {
            const nextTaskId = await this.findCurrentProcessTaskId(store.getState().process.taskModel);
            if (!nextTaskId || nextTaskId === completedTaskId) return false;

            this.openSnackBar(
                "Задача уже была завершена, открываем текущий шаг процесса",
                { severity: "warning", location: { horizontal: "center", vertical: "top" } }
            );
            await this.claimTask(nextTaskId);

            return true;
        } catch (error) {
            console.error("не удалось перейти на текущую задачу процесса", error);
            return false;
        }
    }

    private reloadAfterTaskGone(url: string) {
        this.openSnackBar(
            "Задача уже завершена другим процессом, страница будет обновлена",
            { severity: "warning", location: { horizontal: "center", vertical: "top" } }
        );

        setTimeout(() => window.location.assign(url), 2500);
    }

    private async completeTask(blockUI?: boolean, variables?: any) {
        const request = this.getCompleteTask(variables);
        if (!this.beginCompleting(request.taskId)) return;

        this.startLoading(blockUI);
        await api.camunda.completeTask(request).then((task) => {
            this.stopLoading(blockUI);
            if (!!task) {
                this.updateTaskModelWithHistory(task);
                this.redirectTo(task);
            } else {
                // window.location.assign("/app/queue");
                window.location.assign("/cash-balance");
            }
        }).catch(async (error) => {
            this.stopLoading(blockUI);
            this.closeBackDrop();

            if (await this.resumeMovedProcess(request.taskId)) return;

            if (this.isTaskGoneError(error)) {
                this.reloadAfterTaskGone("/cash-balance");
                return;
            }

            this.endCompleting(request.taskId);
            throw error;
        });
    }

    private completeTaskMsg(blockUI?: boolean, msg?: string) {
        const request = this.getCompleteTask();
        if (!this.beginCompleting(request.taskId)) return;

        this.startLoadingMsg(blockUI, msg);
        api.camunda.completeTask(request).then((task) => {
            this.stopLoading(blockUI);
            if (!!task) {
                this.updateTaskModelWithHistory(task);
                this.redirectTo(task);
            } else {
                window.location.assign("/app/queue");
            }
        }).catch(async (error) => {
            this.stopLoading(blockUI);
            this.closeBackDrop();

            if (await this.resumeMovedProcess(request.taskId)) return;

            if (this.isTaskGoneError(error)) {
                this.reloadAfterTaskGone("/app/queue");
                return;
            }

            this.endCompleting(request.taskId);
            throw error;
        });
    }

    public flow(blockUI?: boolean, buttons?: Object) {
        store.dispatch(updateFlowButton(buttons));
        this.completeTask(blockUI);
    }

    private queueRequestSeq = {
        acceptQueue: 0,
        cashierRequestQueue: 0,
        cashTransferQueue: 0,
        cashRequestQueue: 0,
    };

    public async fetchQueueData({ acceptQueue = false, cashierRequestQueue = false, cashTransferQueue = false, cashRequestQueue = false, }: { acceptQueue?: boolean, cashierRequestQueue?: boolean, cashTransferQueue?: boolean, cashRequestQueue?: boolean }) {
        await api.camunda
            .getUserQueues()
            .then(
                queues => {
                    store.dispatch(headerActions.updateUserQueue([...queues]));
                    store.dispatch(headerActions.updateQueueMenu([...queues]));

                    if (acceptQueue) {
                        const acceptsQueue = queues?.find((queue) => queue.process === QueueEnum.Accepts);
                        if (acceptsQueue) {
                            const seq = ++this.queueRequestSeq.acceptQueue;
                            api.camunda.getQueueList(acceptsQueue?.id, 1, 25)
                                .then((res: QueueResponse) => {
                                    if (seq !== this.queueRequestSeq.acceptQueue) return;
                                    store.dispatch(headerActions.updateAcceptsQueue(res?.queue || []));
                                });
                        }
                    }

                    if (cashierRequestQueue) {
                        const cashierQueue = queues?.find((queue) => queue.process === QueueEnum.CashierRequest);
                        if (cashierQueue) {
                            const seq = ++this.queueRequestSeq.cashierRequestQueue;
                            api.camunda.getQueueList(cashierQueue?.id, 1, 25)
                                .then((res: QueueResponse) => {
                                    if (seq !== this.queueRequestSeq.cashierRequestQueue) return;
                                    store.dispatch(headerActions.updateCashierRequestQueue(res?.queue || []));
                                });
                        }
                    }

                    if (cashTransferQueue) {
                        const cashTransferQueueData = queues?.find((queue) => queue.process === QueueEnum.CashTransfer);
                        if (cashTransferQueueData) {
                            const seq = ++this.queueRequestSeq.cashTransferQueue;
                            api.camunda.getQueueList(cashTransferQueueData?.id, 1, 10)
                                .then((res: QueueResponse) => {
                                    if (seq !== this.queueRequestSeq.cashTransferQueue) return;
                                    store.dispatch(headerActions.updateCashTransferRequestQueue(res?.queue || []));
                                });
                        }
                    }

                    if (cashRequestQueue) {
                        const cashRequestQueueData = queues?.find((queue) => queue.process === QueueEnum.CashRequest);
                        if (cashRequestQueueData) {
                            const seq = ++this.queueRequestSeq.cashRequestQueue;
                            api.camunda.getQueueList(cashRequestQueueData?.id, 1, 10)
                                .then((res: QueueResponse) => {
                                    if (seq !== this.queueRequestSeq.cashRequestQueue) return;
                                    store.dispatch(headerActions.updateCashRequestQueue(res?.queue || []));
                                });
                        }
                    }
                },
                error => {
                    console.log(error);
                }
            )
            .catch(error => {
                console.log(error);
            });
    }

    /**
     * @deprecated The method should not be used
     */
    public go(direction: string, params?: { model?: any; blockUI?: boolean, variables?: any }) {
        switch (direction) {
            case ":forth": this.goForth(params); break;
            case ":back": this.goBack(params?.blockUI); break;
            case ":save": this.save(params?.blockUI); break;
            case ":retry": this.retry(params?.blockUI); break;
            case ":exit": this.exit(() => { }, params?.blockUI); break;
            default: this.goForth(params); break;
        }
    }
    /**
     * @deprecated The method should not be used
     */
    public async goForth(params?: { model?: any; blockUI?: boolean, variables?: any }) {
        const { model, blockUI } = params || {};

        store.dispatch(
            updateTaskButton({
                forth: true,
                back: false,
                exit: false,
                retry: false,
                save: false,
            })
        );
        if (!!model) {
            store.dispatch(
                updateTaskVariables(
                    (g) => g,
                    (s) => ({ ...model, ...s })
                )
            );
        }
        await this.completeTask(blockUI, params?.variables);
    }
    /**
     * @deprecated The method should not be used
     */
    public goForthMsg(params?: { model?: any; blockUI?: boolean; msg?: string }) {
        const { model, blockUI, msg } = params || {};

        store.dispatch(
            updateTaskButton({
                forth: true,
                back: false,
                exit: false,
                retry: false,
                save: false,
            })
        );
        if (!!model) {
            store.dispatch(
                updateTaskVariables(
                    (g) => g,
                    (s) => ({ ...model, ...s })
                )
            );
        }
        this.completeTaskMsg(blockUI, msg);
    }
    /**
     * @deprecated The method should not be used
     */
    public goForthExit(params: {
        callback?: () => void;
        model?: any;
        blockUI?: boolean;
    }) {
        const { callback, model, blockUI } = params;

        store.dispatch(
            updateTaskButton({
                forth: true,
                back: false,
                exit: false,
                retry: false,
                save: false,
            })
        );
        if (!!model) {
            store.dispatch(
                updateTaskVariables(
                    (g) => g,
                    (s) => ({ ...model, ...s })
                )
            );
        }
        this.startLoading(blockUI);
        api.camunda.completeTask(this.getCompleteTask()).then(() => {
            this.stopLoading(blockUI);
            if (!!callback) {
                callback();
            }
        });
    }
    /**
     * @deprecated The method should not be used
     */
    public goBack(blockUI?: boolean) {
        store.dispatch(
            updateTaskButton({
                forth: false,
                back: true,
                exit: false,
                retry: false,
                save: false,
            })
        );
        this.completeTask(blockUI);
    }
    /**
     * @deprecated The method should not be used
     */
    public goBackExit(callback: () => void, blockUI?: boolean) {
        store.dispatch(
            updateTaskButton({
                forth: false,
                back: true,
                exit: false,
                retry: false,
                save: false,
            })
        );
        this.startLoading(blockUI);
        api.camunda.completeTask(this.getCompleteTask()).then(() => {
            this.stopLoading(blockUI);
            callback();
        });
    }
    /**
     * @deprecated The method should not be used
     */
    public exit(callback?: () => void, blockUI?: boolean) {
        store.dispatch(
            updateTaskButton({
                forth: false,
                back: false,
                exit: true,
                retry: false,
                save: false,
            })
        );
        this.startLoading(blockUI);
        api.camunda.completeTask(this.getCompleteTask()).then((task) => {
            this.stopLoading(blockUI);
            if (!!task) {
                this.updateTaskModelWithHistory(task);
                this.redirectTo(task);
            } else {
                if (!!callback) {
                    callback();
                } else {
                    window.location.assign("/cash-balance");
                }
            }
        });
    }
    /**
     * @deprecated The method should not be used
     */
    public retry(blockUI?: boolean) {
        store.dispatch(
            updateTaskButton({
                forth: false,
                back: false,
                exit: false,
                retry: true,
                save: false,
            })
        );
        this.completeTask(blockUI);
    }
    /**
     * @deprecated The method should not be used
     */
    public retryExit(callback: () => void, blockUI?: boolean) {
        store.dispatch(
            updateTaskButton({
                forth: false,
                back: false,
                exit: false,
                retry: true,
                save: false,
            })
        );
        this.startLoading(blockUI);
        api.camunda.completeTask(this.getCompleteTask()).then(() => {
            this.stopLoading(blockUI);
            callback();
        });
    }
    /**
     * @deprecated The method should not be used
     */
    public save(blockUI?: boolean) {
        store.dispatch(
            updateTaskButton({
                forth: false,
                back: false,
                exit: false,
                retry: false,
                save: true,
            })
        );
        this.completeTask(blockUI);
    }
    /**
     * @deprecated The method should not be used
     */
    public saveExit(callback: () => void, blockUI?: boolean) {
        store.dispatch(
            updateTaskButton({
                forth: false,
                back: false,
                exit: false,
                retry: false,
                save: true,
            })
        );
        this.startLoading(blockUI);
        api.camunda.completeTask(this.getCompleteTask()).then(() => {
            this.stopLoading(blockUI);
            callback();
        });
    }

    public updateTaskModelWithHistory(task?: Task) {
        this.setVars(task);
        store.dispatch(updateTaskModel(task));
        // api.camunda
        //   .getTaskHistory((task || {}).processInstanceId)
        //   .then((history) => {
        //     store.dispatch(updateTaskHistory(history));
        //   });
    }

    public assignTask(taskId: string, username: string) {
        this.startLoading();
        api.camunda.assignTask(taskId, username).then((task) => {
            store.dispatch(updateTaskModel(task));
            this.stopLoading();
        });
    }

    public openTask(taskId: string) {
        this.startLoading();
        api.camunda.getTask(taskId).then((task) => {
            this.stopLoading();
            this.updateTaskModelWithHistory(task);
            this.redirectTo(task);
        });
    }

    public openReadOnlyTask(taskId: string) {
        this.startLoading();
        api.camunda.getTask(taskId).then((task) => {
            this.stopLoading();
            this.updateTaskModelWithHistory(task);
            this.redirectToReadonlyTask();
        });
    }

    public async claimTask(taskId: string) {
        this.startLoading();
        await api.camunda.claimTask(taskId).then((task) => {
            if (task) {
                this.updateTaskModelWithHistory(task);
                this.redirectTo(task);
            }
            this.stopLoading();
        });
    }

    public claimDistributedTask(queueId: number) {
        this.startLoading();
        api.camunda.getDistributedTask(queueId).then((task) => {
            this.stopLoading();
            this.updateTaskModelWithHistory(task);
            this.redirectTo(task);
        });
    }

    public restoreTaskModelAfterRefreshingPage(callback: () => void) {
        // Ищем сегмент после "task", а не фиксированный индекс: проверка
        // paths[2] === "task" была написана под префикс /app, а сейчас
        // PUBLIC_URL пустой и путь начинается сразу с /task/<id>. Из-за этого
        // ветка не срабатывала вообще, и страница задачи после перезагрузки
        // держалась только на taskModel из снимка localStorage.
        const paths = window.location.pathname.split("/").filter(Boolean);
        const taskIndex = paths.indexOf("task");
        const taskId = taskIndex >= 0 ? paths[taskIndex + 1] : undefined;

        if (!taskId) {
            callback();
            return;
        }

        this.startLoading();
        api.camunda.getTask(taskId)
            .then((task) => {
                this.stopLoading();
                this.updateTaskModelWithHistory(task);
                callback();
                if (!this.isUrlsMatch(task)) {
                    this.redirectTo(task);
                }
            })
            .catch((error) => {
                // Без callback приложение вообще не отрисуется (root.render
                // вызывается только из него) - белый экран вместо страницы.
                console.error("Не удалось восстановить задачу после перезагрузки", error);
                this.stopLoading();
                callback();
            });
    }

    public getTaskHistory(): HistoricProcessAndTaskInstances {
        const history: HistoricProcessAndTaskInstances =
            store.getState().process.history || [];

        return history;
    }

    public startLoading(blockUI?: boolean) {
        if (!!blockUI) {
            this.openBackDrop("Загрузка данных...", true, 100);
        } else {
            store.dispatch(startLoading());
        }
    }

    public startLoadingMsg(blockUI?: boolean, msg?: string) {
        if (!!blockUI) {
            this.openBackDrop(msg, true, 100);
        } else {
            store.dispatch(startLoading());
        }
    }

    public stopLoading(blockUI?: boolean) {
        if (!!blockUI) {
            this.closeBackDrop();
        } else {
            store.dispatch(stopLoading());
        }
    }

    public openSnackBar(message: string | ReactNode, { ...props }: PopupSnackBarProps = { severity: "success", location: { horizontal: "right", vertical: "top" } }) {
        store.dispatch(
            openSnackBar({ open: true, message: message, ...props })
        );
    }

    public closeSnackBar() {
        store.dispatch(closeSnackBar());
    }

    public openBackDrop(text?: string, disableShrink?: boolean, size?: number) {
        store.dispatch(openBackDrop(text, disableShrink, size));
    }

    public closeBackDrop() {
        store.dispatch(closeBackDrop());
    }

    public openConfirm(handleAgree: () => void, text: string, title?: string) {
        store.dispatch(openConfirm({
            open: true, text: text, title: title, handleAgree: () => {
                handleAgree();
                store.dispatch(closeConfirm());
            },
            handleDisagreeOrClose: () => store.dispatch(closeConfirm())
        }));
    }

    public redirectTo(task?: Task, url = "/cash-balance") {
        this.closeBackDrop();

        if (!!task) {
            const process = ((task || {}).processDefinitionId || "").split(":")[0];
            const activity = (task || {}).definitionKey || "";
            if (task?.form) {
                history.push(
                    `${basePath}/task/${(task || {}).id}`
                );
            } else {
                history.push(
                    `${basePath}/task/${(task || {}).id}/${process}/${activity}`
                );
            }
        } else {
            window.location.assign(url);
        }
    }

    public redirectToReadonlyTask() {
        this.closeBackDrop();
        history.push(`${basePath}/readonlyTask`);
    }

    private isUrlsMatch(task?: Task): boolean {
        const process = ((task || {}).processDefinitionId || "").split(":")[0];
        const url = `${basePath}/task/${(task || {}).id}/${process}/${(task || {}).definitionKey
            }`;
        return url == window.location.pathname;
    }

    public getTaskModelVariables() {
        return (store.getState().process.taskModel || {}).variables || {};
    }

    public getTaskModel() {
        return store.getState().process.taskModel || {};
    }

    private setVars(task?: Task) {
        (window as any).vars = (task || {}).variables?.vars;
    }

    public hasCacheKey(key: string): boolean {
        const items = this.getCacheItems();
        return items.hasOwnProperty(key);
    }

    public setCacheItem(key: string, item: any) {
        store.dispatch(cacheActions.add({ [key]: item }));
    }

    public getCacheItems() {
        const items = store.getState().cache.items || {};
        return items;
    }
}

const processManager = new ProcessManger();
export default processManager;
